import { Button, Typography } from "@suraasa/placebo-ui"
import CpatMiniLogo from "features/Cpat/assets/cpat-mini-logo.png"
import { ArrowRight } from "iconoir-react"

const GetStartedWithCpatOnboarding = ({ onStart }: { onStart: () => void }) => {
  return (
    <div>
      <div className="mx-2 md:mx-12">
        <img
          src={CpatMiniLogo}
          alt="cpat-mini-logo"
          className="mb-2 size-5 sm:size-8"
        />
        <Typography variant="title1" className="mb-2">
          Let’s Personalize your Experience
        </Typography>

        <Typography variant="largeBody" className="max-w-xl text-onSurface-500">
          Before you take CPAT, tell us about your teaching background. This
          helps us understand you better and ensures your report truly reflects
          your teaching journey.
        </Typography>
        <div className="h-6"></div>
        <Button
          onClick={onStart}
          color="black"
          size="lg"
          endAdornment={<ArrowRight className="!size-2" />}
        >
          Let&apos;s Begin
        </Button>
      </div>
    </div>
  )
}

export default GetStartedWithCpatOnboarding
